module.exports = __webpack_public_path__ + "img/medical_team_black.e2591a5d.svg";